import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[appInput]'
})
export class InputDirective {

  @HostBinding('class') classes = "rounded border-gray-300 block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"

  constructor() { }

}
